import {Component, OnInit} from '@angular/core';
import {SearchForm} from '../../../sdk/component/search/searchForm';
import {Router} from '@angular/router';
import {SearchService} from '../../../sdk/component/search/search.service';
import {ROUTES} from '../../../app.routes';
import {Account, AccountsSortField, AccountType, WebQRService} from 'web-angular-client';
import {AuthenticationService} from '../../../sdk/service/authentication.service';
import {AccountStatusUtil} from '../../../sdk/interface/accountStatusUtil';
import {AlertService} from '../../../sdk/service/alert.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {EnvironmentService} from '../../../sdk/service/environment.service';

@Component({
    selector: 'qr-payments-dashboard',
    templateUrl: './qr-payments-dashboard.component.html',
    styleUrls: ['./qr-payments-dashboard.component.scss'],
    standalone: false
})
export class QrPaymentsDashboardComponent extends SearchForm implements OnInit
{

    sortFields: SortField[];
    selectedSortField: SortField | null;
    protected readonly AccountType = AccountType;

    constructor(
        private router: Router,
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService,
        private webQrService: WebQRService,
        protected searchService: SearchService,
        protected accountStatusUtil: AccountStatusUtil,
        private ngxLoader: NgxUiLoaderService,
        private alertService: AlertService)
    {
        super(authenticationService, webQrService, searchService, environmentService);
        this.sortFields = [
            {id: 'dateTimeCreated', name: 'Date Created'},
            {id: 'description', name: 'Description'},
            {id: 'referenceNumber', name: 'Reference'},
            {id: 'amountPaid', name: 'Amount'}
        ];
    }

    get contents(): [Account]
    {
        return this.results?.content;
    }

    create()
    {
        // not used but required to be implemented
    }

    view(qrPayment: Account)
    {
        if (this.isGuestAdminUser())
        {
            this.displayGuestPrivilegeError();
            return;
        }

        this.router.navigate([ROUTES.SECURE.ACCOUNT.VIEW.pathSansParameters, qrPayment.id]).then();
    }

    getDefaultSortField(): string
    {
        return AccountsSortField.ID;
    }

    public getAccountStatusUtil(): AccountStatusUtil
    {
        return this.accountStatusUtil;
    }


    getAmount(qrPayment: Account): number
    {
        return !!qrPayment.dateTimePaid ? qrPayment.amountPaid : qrPayment.amount;
    }

    private displayGuestPrivilegeError(): void
    {
        this.alertService.error('Guest accounts cannot perform this action.', false);
    }
}

interface SortField
{
    id: string;
    name: string;
}